import React from 'react'
import PropTypes from 'prop-types'
import { Link, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'

import Layout from '../components/Layout'
import StoreWidget from '../components/StoreWidget'

export const IndexPageTemplate = ({
  image,
  main,
}) => (
  <div>
    <div
      className="full-width-image margin-top-0"
      style={{
        backgroundImage: `url(${
          !!image.childImageSharp ? image.childImageSharp.fluid.src : image
        })`,
        backgroundAttachment: "fixed",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        height: "85vh",
      }}
    >
    </div>
    <div className="center accent width100">
      <div className="container-inline-flex" >
        <div
          className="portrait-image-container"
          style={{
            marginRight: "30px",
            backgroundImage: `url(${
              main.image.image.childImageSharp
                ? main.image.image.childImageSharp.fluid.src
                : main.image.image
            })`,
          }}
        />
        <div className="width50">
          <p>
            {main.quote}
          </p>
        </div>
      </div>
    </div>
    <StoreWidget/>
  </div>
)

IndexPageTemplate.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  main: PropTypes.shape({
    blurbs: PropTypes.array,
  }),
}

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark

  return (
    <Layout>
      <Helmet titleTemplate="Ancestral Link | %s">
        <title>Home</title>
      </Helmet>
      <IndexPageTemplate
        image={frontmatter.image}
        main={frontmatter.main}
      />
    </Layout>
  )
}

IndexPage.propTypes = {
  data: PropTypes.shape({
    markdownRemark: PropTypes.shape({
      frontmatter: PropTypes.object,
    }),
  }),
}

export default IndexPage

export const pageQuery = graphql`
  query IndexPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "index-page" } }) {
      frontmatter {
        image {
          childImageSharp {
            fluid(maxWidth: 2048, quality: 100) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        main {
          quote
          image {
            alt
            image {
              childImageSharp {
                fluid(maxWidth: 240, quality: 64) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    }
  }
`
